// Apolo IDE — usePlanFileUpload (sprint plan-tab-v1, E4+).
//
// Upload genérico de QUALQUER formato de arquivo: cria plan_file + multipart
// pro endpoint /upload (R2, Content-Type correto). Retorna metadata do file.

import { useCallback, useState } from 'react';
import { getStoredToken } from '../lib/api.js';
import { apiUrl } from '../lib/apiBase.js';
import { createPlanFile } from '../lib/plan/api.js';

export function usePlanFileUpload(planId) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const upload = useCallback(async (file) => {
    if (!planId || !file) return { ok: false };
    setUploading(true);
    setError(null);

    const created = await createPlanFile(planId, { kind: 'file', name: file.name || 'arquivo' });
    if (!created.ok || !created.data?.file?.id) {
      setUploading(false);
      setError(created.error || 'falha ao criar file');
      return { ok: false, error: created.error };
    }
    const fileId = created.data.file.id;
    const form = new FormData();
    form.append('file', file);
    try {
      const res = await fetch(
        apiUrl(`/api/plan/${encodeURIComponent(planId)}/files/${encodeURIComponent(fileId)}/upload`),
        { method: 'POST', headers: { Authorization: `Bearer ${getStoredToken()}` }, body: form },
      );
      setUploading(false);
      if (!res.ok) {
        setError(`upload falhou (${res.status})`);
        return { ok: false, error: `status ${res.status}` };
      }
      const data = await res.json();
      return { ok: true, fileId, kind: data.kind, name: data.name, size_bytes: data.size_bytes, mime: data.mime };
    } catch (e) {
      setUploading(false);
      setError(e?.message || 'network failure');
      return { ok: false, error: e?.message };
    }
  }, [planId]);

  return { upload, uploading, error };
}
